import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-price-management',
    templateUrl: './price-management.component.html',
    styleUrls: ['./price-management.component.scss']
})
export class PriceManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
